import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import CustomDialog from "../../shared/Layouts/CustomDialog";
import { CustomGridLayout } from "../../shared/Layouts/FormPage";
import { CustomCheckBox, CustomDropDown, CustomInput } from "../../shared/AllInput";
import { useDispatch, useSelector } from "react-redux";
import { addQrCodeAction, assignQRtoExecutive, getQRList } from "../../redux/actions/qrCodeAction";
import useCustomQRs from "./useCustomQRs";
import { useParams } from "react-router-dom";
import { Tag } from "primereact/tag";
import { FilterMatchMode } from "primereact/api";
import { getExecutives } from "../../redux/actions/executiveAction";
import { showToast } from "../../redux/actions/toastAction";
import { Paginator } from "primereact/paginator";
import { ProgressBar } from "primereact/progressbar";
import { Dialog } from "primereact/dialog";
import { hasPermission } from "../../utils/adminPermissions";
import api from "../../services/api";
import Constants from "../../services/constants";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function QRCodeTable({
    heading,
    allQRCode,
    loading,
    history,
    search,
    setSearch,
    setLoading,
    page,
    limit,
    totalRecords,
    setPage,
    setLimit,
    setSelectedStatus,
    selectedStatus,
}) {
    const { id } = useParams();
    const [selectedRow, setSelectedRow] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const dispatch = useDispatch();
    const { userProfile } = useSelector((state) => state.profile);
    const canCreate = hasPermission(userProfile, "qr_code.create");
    const canAssign = hasPermission(userProfile, "qr_code.assign");

    const [statuses] = useState(["NEW", "ASSIGNED", "ACTIVE", "INACTIVE"]);
    const [exporting, setExporting] = useState(false);
    const [rangeFrom, setRangeFrom] = useState("");
    const [rangeTo, setRangeTo] = useState("");
    const [downloadingRange, setDownloadingRange] = useState(false);
    let allExecutives = useSelector((state) => state.executive.allExecutives);

    useEffect(() => {
        dispatch(getExecutives());
    }, [dispatch]);

    const getSeverity = (status) => {
        switch (status) {
            case "ACTIVE":
                return "success";
            case "ASSIGNED":
                return "info";
            case "NEW":
                return "warning";
            case "INACTIVE":
                return "danger";
            default:
                return null;
        }
    };

    const [data, setData] = useState({
        quantity: "",
        isDownload: true,
        assignedTo: "",
    });

    const handleChange = ({ name, value }) => {
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const actions = (d) => {
        return (
            <div className="flex justify-content-around">
                <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/qr-code/view/${d._id}`)}></i>
            </div>
        );
    };

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };

    const filters = {
        activityAt: { operator: "and", constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
    };

    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const onClose = () => {
        setVisible(false);
    };

    const onCloseDialog = () => {
        setVisibleDialog(false);
    };

    let { zipProgress, creationProgress, OnDownload, OnDownloadPNG, cancelDownload } = useCustomQRs();

    const handleSave = () => {
        dispatch(
            addQrCodeAction(data, (res) => {
                data.isDownload === true && OnDownload(res);
                onClose();
                dispatch(getQRList(page, limit, search, selectedStatus));
            })
        );
    };

    const handleAssign = () => {
        if (!data.assignedTo) return;
        const assignedId = data?.assignedTo?._id;
        const qrCodes = selectedRow?.map((item) => {
            return item._id;
        });
        dispatch(
            assignQRtoExecutive(assignedId, qrCodes, () => {
                onCloseDialog();
                dispatch(getQRList(page, limit, search, selectedStatus));
            })
        );
        setSelectedRow([]);
    };

    const userDetails = (r) => {
        const userId = r?.vehicle?.user?.userId;
        const userDBId = r?.vehicle?.user?._id;
        return (
            (
                <span style={{ cursor: "pointer" }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                    {userId}
                </span>
            ) ?? null
        );
    };

    const executiveDetails = (r) => {
        const executiveEmail = r?.assignedTo?.email;
        const executiveId = r?.assignedTo?._id;

        return (
            (
                <span style={{ cursor: "pointer" }} className="link" onClick={() => history(`/executive/view/${executiveId}`)}>
                    {executiveEmail}
                </span>
            ) ?? null
        );
    };

    const vehicleNumber = (r) => {
        const data = r?.vehicle?.vehicleNumber;
        return data ?? null;
    };

    const statusFilterTemplate = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={statuses}
                onChange={(e) => options.filterApplyCallback(e.value)}
                itemTemplate={statusItemTemplate}
                placeholder="Select One"
                className="p-column-filter"
                showClear
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.status} severity={getSeverity(rowData.status)} />;
    };

    // Function to handle pagination change
    const onPageChange = (event) => {
        setPage(event.page + 1);
        setLimit(event.rows);
    };

    const statusItemTemplate = (option) => {
        return <Tag value={option} severity={getSeverity(option)} />;
    };

    const statusOptions = [
        { name: selectedStatus ? "All" : "Select Status", value: "" },
        { name: "Active", value: "ACTIVE" },
        { name: "Assigned", value: "ASSIGNED" },
        { name: "New", value: "NEW" },
        { name: "Inactive", value: "INACTIVE" },
    ];

    // Both fields required, numeric, > 0, and From <= To. Shared by the
    // button's disabled check and the actual download so they can't drift.
    const getValidRange = () => {
        const from = parseInt(rangeFrom, 10);
        const to = parseInt(rangeTo, 10);
        if (!rangeFrom || !rangeTo || Number.isNaN(from) || Number.isNaN(to) || from <= 0 || to <= 0 || from > to) {
            return null;
        }
        return { from, to };
    };

    // See CallLogsTable.jsx for why this bypasses the redux action.
    const downloadRange = async () => {
        const range = getValidRange();
        if (!range) {
            dispatch(showToast({ severity: "warn", summary: "Enter a valid range: From and To must both be greater than 0, with From ≤ To" }));
            return;
        }
        setDownloadingRange(true);
        try {
            const url = `${Constants.END_POINT.QR_CODE}?page=1&limit=10000&srNoFrom=${range.from}&srNoTo=${range.to}`;
            const res = await api("get", url);
            const rows = res?.data?.data || [];
            if (!rows.length) {
                dispatch(showToast({ severity: "warn", summary: "No QR codes found in that serial number range" }));
                return;
            }
            await OnDownloadPNG(rows);
        } finally {
            setDownloadingRange(false);
        }
    };

    // See CallLogsTable.jsx for why this bypasses the redux action.
    const exportAll = async () => {
        setExporting(true);
        try {
            const url = `${Constants.END_POINT.QR_CODE}?page=1&limit=10000&search=${encodeURIComponent(search || "")}&status=${selectedStatus || ""}`;
            const res = await api("get", url);
            const rows = res?.data?.data || [];
            exportTableToCsv("qr-codes.csv", rows, [
                { header: "QR Code", value: "srNo" },
                { header: "Assigned To", value: (row) => row?.assignedTo?.email || "-" },
                { header: "Vehicle Number", value: (row) => row?.vehicle?.vehicleNumber || "-" },
                { header: "Status", value: "status" },
                { header: "Activity Date", value: (row) => (row.activityAt ? formatDate(new Date(row.activityAt)) : "-") },
            ]);
        } finally {
            setExporting(false);
        }
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
                        <h5 className="m-0">{heading}</h5>
                        {setSearch ? (
                            <div className="flex flex-wrap align-items-center gap-2">
                                <Dropdown
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        setPage(1);
                                        setSelectedStatus(e.value);
                                    }}
                                    optionLabel="name"
                                    placeholder={"Select Status"}
                                    options={statusOptions}
                                    style={{ width: "10rem" }}
                                />
                                <div className="p-input-icon-left">
                                    <i className="pi pi-search" />
                                    <InputText
                                        value={search}
                                        onChange={(e) => {
                                            setPage(1);
                                            setSearch(e.target.value);
                                        }}
                                        placeholder="Search"
                                    />
                                </div>
                                {!id && canCreate && (
                                    <PrimaryButton style={{ whiteSpace: "nowrap" }} onClick={() => setVisible(true)}>
                                        Add Qr Code
                                    </PrimaryButton>
                                )}
                                <div className="flex flex-nowrap align-items-center gap-2">
                                    <InputText
                                        value={rangeFrom}
                                        onChange={(e) => setRangeFrom(e.target.value.replace(/\D/g, ""))}
                                        placeholder="From #"
                                        style={{ width: "5.5rem" }}
                                        keyfilter="int"
                                    />
                                    <span>-</span>
                                    <InputText
                                        value={rangeTo}
                                        onChange={(e) => setRangeTo(e.target.value.replace(/\D/g, ""))}
                                        placeholder="To #"
                                        style={{ width: "5.5rem" }}
                                        keyfilter="int"
                                    />
                                    <PrimaryButton
                                        label="Download Range (PDF)"
                                        onClick={downloadRange}
                                        loading={downloadingRange}
                                        disabled={!getValidRange()}
                                        style={{ whiteSpace: "nowrap" }}
                                    />
                                </div>
                                <PrimaryButton
                                    label="Export CSV"
                                    icon="pi pi-download"
                                    onClick={exportAll}
                                    loading={exporting}
                                    disabled={!totalRecords}
                                    severity="success"
                                    style={{ whiteSpace: "nowrap" }}
                                />
                                {selectedRow?.length > 0 && (
                                    <>
                                        <PrimaryButton onClick={() => OnDownloadPNG(selectedRow)}>Download</PrimaryButton>
                                        {!id && canAssign && <PrimaryButton onClick={() => setVisibleDialog(selectedRow)}>Assign QRs</PrimaryButton>}
                                    </>
                                )}
                            </div>
                        ) : null}
                    </div>
                    <Dialog
                        header=""
                        className=""
                        visible={creationProgress > 0 || zipProgress > 0}
                        contentClassName=""
                        style={{ width: "50vw" }}
                        onHide={cancelDownload}
                    >
                        {creationProgress > 0 && (
                            <>
                                <h4>Creating</h4>
                                <ProgressBar value={creationProgress} className="mb-5" />
                            </>
                        )}
                        {zipProgress > 0 && (
                            <>
                                <h4>Downloading</h4>
                                <ProgressBar value={zipProgress} className="mb-5" />
                            </>
                        )}
                    </Dialog>

                    <DataTable
                        // paginator
                        value={allQRCode}
                        selection={selectedRow}
                        onSelectionChange={(e) => setSelectedRow(e.value)}
                        selectionMode="checkbox"
                        filters={filters}
                        emptyMessage="No QRCode found."
                        className=""
                        showGridlines
                        first={(page - 1) * limit}
                        rows={limit}
                        totalRecords={totalRecords || 0}
                        onPage={onPageChange}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                        <Column field="srNo" header="QR Code"></Column>
                        {/* <Column body={userDetails} header="UserId"></Column> */}
                        <Column body={executiveDetails} header="Assigned To"></Column>
                        <Column body={vehicleNumber} header="Vehicle Number"></Column>
                        <Column field="status" header="Status" body={statusBodyTemplate}></Column>
                        <Column
                            header="Activity Date"
                            field="activityAt"
                            dataType="date"
                            style={{ width: "150px" }}
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.activityAt)}
                            filter
                            filterElement={dateFilterTemplate}
                        />
                        <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
                    </DataTable>
                    <Paginator
                        first={(page - 1) * limit}
                        rows={limit}
                        totalRecords={totalRecords || 0}
                        onPageChange={onPageChange}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                    />
                </div>
            </div>

            <CustomDialog title="Add QRCode" visible={visible} onCancel={onClose} loading={loading} onSave={handleSave}>
                <CustomGridLayout>
                    <CustomInput col="12" name="quantity" label="Number Of QR" data={data} onChange={handleChange} keyfilter="int" />
                    <CustomCheckBox col="12" name="isDownload" label="Download QR on Save?" data={data} onChange={handleChange} />
                </CustomGridLayout>
            </CustomDialog>

            <CustomDialog title="Assign QRCode" visible={visibleDialog} onCancel={onCloseDialog} loading={loading} onSave={handleAssign}>
                <CustomGridLayout>
                    <CustomDropDown
                        col={12}
                        data={data}
                        options={allExecutives}
                        label={"Executive"}
                        name="assignedTo"
                        optionLabel={"firstName" ? "firstName" : "email"}
                        onChange={handleChange}
                    />
                </CustomGridLayout>
            </CustomDialog>
        </>
    );
}
